import { makeVar, useReactiveVar } from '@apollo/client'

// A counter bumped each time something requests the palette to open. A counter
// (rather than a boolean) ensures each request re-triggers the open effect even
// when the palette was opened and closed again in between.
const openRequestVar = makeVar(0)

/**
 * Opens the command palette from anywhere in the app (e.g. the welcome page's
 * search input). The palette is mounted once in the authenticated shell and
 * reacts to this request.
 */
export const openCommandPalette = (): void => {
  openRequestVar(openRequestVar() + 1)
}

export const useCommandPaletteOpenRequest = (): number =>
  useReactiveVar(openRequestVar)
